// @ts-ignore
import { ReactComponent as Spinner } from "../icons/spinner-icon/spinner.icon.svg";

export const ICONS = {
  Spinner,
};
